export default __webpack_public_path__ + "static/referentna lista piperski-549f9ccdda0877833ef990176c6683dc.pdf";